import { groupBy } from 'lodash';

export const truncateString = (text, length) => {
  if (!text) text = '';

  if (text?.length > length) {
    return `${text?.substring(0, length)}...`;
  }
  return text;
};

// Get tag based on group
const tagGroup = ['age', 'area', 'needs', 'type', 'category', 'industry'];

export const getTagsBasedOnGroup = (tags) => {
  const sortArr = tags?.sort((a, b) => tagGroup.indexOf(a.group) - tagGroup.indexOf(b.group));

  const groupBasedArr = sortArr.reduce((acc, curr) => {
    const node = acc.find((item) => item.find((subItem) => subItem.group === curr.group));
    node ? node.push(curr) : acc.push([curr]);
    return acc;
  }, []);

  const results = groupBasedArr.map((element) => element.sort((a, b) => a.order_number - b.order_number)).flat();

  return results;
};
